<!--
 * 示例文件弹窗组件
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="50%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :destroy-on-close="true"
    :fullscreen="fullscreen">
    <div slot="title" class="d-flex justify-content-between">
      <div class="title">{{ content ? $t(content.title) : "" }}</div>
      <div class="header-btn">
        <slot></slot>
        <el-button type="text" size="mini" class="full-btn" @click="fullFn">
          <i class="el-icon-full-screen"></i>
        </el-button>
      </div>
    </div>
    <slot name="content">
      <template v-if="content">
        <diyelInput
          v-if="searchShow"
          placeholder="请输入内容"
          v-model="searchValue"
          clearable
          @clear="sousuo"
          @keyup.enter.native="sousuo"
          class="search-input">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </diyelInput>
        <diy-table
          v-if="wenzi == 'table'"
          ref="diyTable"
          class="diyTable"
          :tableData="tableData"
          @page-change="pageChange"
          :tableHeight="mh"
          :showHeader="showHeader">
        </diy-table>
        <div class="content" :style="{ '--mh': mh }" v-if="wenzi == 'text'">
          {{ content.content }}
        </div>
      </template>
    </slot>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" @click="closeFn" size="mini">{{
        $t("关闭")
      }}</el-button>
      <slot name="footer"></slot>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "diagBox",
  props: {
    //传值
    content: {
      type: [String, Object, Array],
      default: null,
      /* this.diagContent = {//传递表格内容
            title: "查看示例文件",
            filename: filename,
            content: {
              header: heard,
              newtable: shuju,
              table: shuju,
              total: shuju.length,
              pageSize: 10,
              currentPage: 1,
            },
          }; */
    },

    searchShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showHeader: false,
      dialogVisible: false,
      fullscreen: false,
      mh: 300,
      wenzi: null,
      tableData: {
        header: [],
        table: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      searchValue: "",
    };
  },
  components: {
    //引入模块
  },
  watch: {
    // watch擅长处理的场景：一个数据影响多个数据
    content: {
      handler(val) {
        console.log(val);
        if (val && val.content) {
          if (typeof val.content == "string") {
            this.wenzi = "text";
            this.mh = "55vh";
          } else {
            this.wenzi = "table";
            if (!val.content.table) {
              this.tableData.header = val.content[0];
              const start =
                (this.tableData.currentPage - 1) * this.tableData.pageSize;
              const end = start + this.tableData.pageSize;
              var table = val.content.slice(start, end);
              this.tableData.table = table;
              this.tableData.total = val.content.length;
            } else {
              this.tableData = this.$deepCopy(val.content);
              const start =
                (this.tableData.currentPage - 1) * this.tableData.pageSize;
              const end = start + this.tableData.pageSize;
              var table = val.content.table.slice(start, end);
              this.tableData.table = table;
              this.tableData.total = val.content.table.length;
            }
          }
        }

        // { prop: "name", label: "文件名" },
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // computed擅长处理的场景：一个数据受多个数据影响
  },
  mounted: function () {
    // 编译好的HTML挂载到页面完成后执行的事件钩子
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
    console.log("diagBox");
  },
  activated: function () {
    // 狗子触发顺序最后时执行，当再次进入（前进或者后退）时，只触发activated
  },
  methods: {
    // 组件的方法
    pageChange(val) {
      this.tableData.currentPage = val.page;
      this.tableData.pageSize = val.pageSize;
      const start = (this.tableData.currentPage - 1) * this.tableData.pageSize;
      const end = start + this.tableData.pageSize;
      if (!this.content.content.table) {
        var table = this.content.content.slice(start, end);
      } else {
        var table = this.content.content.table.slice(start, end);
      }

      this.tableData.table = table;
    },
    closeFn() {
      this.dialogVisible = false;
      this.searchValue = "";
      this.$emit("close");
    },
    fullFn() {
      this.fullscreen = !this.fullscreen;
      if (this.fullscreen) {
        if (this.wenzi == "table") {
          this.mh = 700;
        }
        if (this.wenzi == "text") {
          this.mh = "75vh";
        }
      } else {
        if (this.wenzi == "table") {
          this.mh = 300;
        }
        if (this.wenzi == "text") {
          this.mh = "55vh";
        }
      }
      this.$emit("fullFn", this.fullscreen);
    },
    sousuo() {
      console.log(this.content.content);
      this.$parent.$parent.lookOpen(this.content.filename, this.searchValue);
    },
  },
  beforeCreate: function () {
    // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  },
  created: function () {
    // 实例已经创建完成之后被调用。在这一步，实例已完成以下的配置：数据观测(data observer)，属性和方法的运算， watch/event 事件回调。然而，挂载阶段还没开始，el 属性目前不可见。
  },
  beforeMount: function () {
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  beforeUpdate: function () {
    // 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  },
  updated: function () {
    // 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    // 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。然而在大多数情况下，你应该避免在此期间更改状态，因为这可能会导致更新无限循环。
    // 该钩子在服务器端渲染期间不被调用。
  },
  beforeDestroy: function () {
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
  },
  destroyed: function () {
    // Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁。 该钩子在服务器端渲染期间不被调用。
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 18px;
}
.header-btn {
  .full-btn {
    font-size: 18px;
    color: #666;
    &:hover {
      color: #3385ff;
    }
  }
}
.content {
  box-sizing: border-box;
  white-space: pre-wrap; /* 保留\t和\n，并允许自动换行 */
  border: 1px solid #ccc;
  padding: 10px;
  width: 100%;
  max-height: var(--mh);
  overflow: auto;
}
.search-input {
  position: sticky;
  top: 60px;
  margin-bottom: 20px;
  background: #fff;
  z-index: 1;
  ::v-deep .el-input__inner {
    border-radius: 36px;
  }
}
</style>
